import * as type from '../types/authTypes'

//Action Creator
export const loginSuccess = (payload) => ({
    type: type.LOGIN_SUCCESS,
    payload
});

export const loginError = () => ({
    type: type.LOGIN_ERROR
});

export const logoutUser = () => ({
    type : type.LOGOUT_USER
})

export const setUserData = (payload) => ({
    type : type.SET_USER_DATA,
    payload
})


// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js